import { Box, Button, Divider, Icon, Paper, Typography } from "@mui/material";
import { AccountReportDto } from "../../../api/psc";

// updated
export default function ReportItem(props: {
    report: AccountReportDto;
    onSelected: () => void;
}) {
    return (
        <Paper key={props.report.type} sx={{ p: 2, mb: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <Icon color="primary">{props.report.icon}</Icon>

                <Typography sx={{ flexGrow: 1, ml: 1 }}>
                    {props.report.title}
                </Typography>

                <Button
                    onClick={props.onSelected}
                    size="small"
                    variant="contained"
                    color="primary"
                >
                    انتخاب
                </Button>
            </Box>

            <Divider sx={{ my: 1.5 }} />

            <Typography color="text.secondary">
                {props.report.description}
            </Typography>
        </Paper>
    );
}
